import { Skeleton } from '@/shared/components/ui/skeleton'

/** Fallback Suspense pour routes chargées en lazy (DESIGN §5). */
export function RouteFallback() {
  return (
    <div className="w-full py-2" aria-busy="true">
      <Skeleton className="h-9 w-56 max-w-full" aria-hidden />
      <Skeleton className="mt-6 h-48 w-full rounded-lg sm:h-72" aria-hidden />
      <Skeleton className="mt-4 h-4 w-full max-w-xl" aria-hidden />
      <Skeleton className="mt-2 h-4 w-2/3 max-w-lg" aria-hidden />
    </div>
  )
}
